<div class="plan page-layout" *transloco="let t">
  <app-pap-autoevaluation-filter (filterUpdated)="setFilter($event)" (export)="exportPage($event)"> </app-pap-autoevaluation-filter>

  <ng-container *ngIf="teacherList$ | withLoader | async as teacherList">
    <div class="portfolio-activity-list page-layout-sub no-gutters">
      <div class="col table-wrapper">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">
                <isophi-app-sortable
                  [fieldName]="'last_name'"
                  [title]="t('pap/autoEvaluation/teacher')"
                  (orderingChange)="onOrderingChange($event)"
                  [(ordering)]="ordering"
                ></isophi-app-sortable>
              </th>
              <th scope="col">{{ t('pap/autoEvaluation/teacherGroups') }}</th>
              <th scope="col">
                <isophi-app-sortable
                  [fieldName]="'last_evaluation_date'"
                  [title]="t('pap/autoEvaluation/lastAutoEvaluation')"
                  (orderingChange)="onOrderingChange($event)"
                  [(ordering)]="ordering"
                ></isophi-app-sortable>
              </th>
              <th scope="col" class="text-end">{{ t('pap/autoEvaluation/nextAutoEvaluation') }}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="teacherList.results.length > 0; else noResults">
              <app-pap-autoevaluation-row
                *ngFor="let teacher of teacherList.results"
                [teacher]="teacher"
                (click)="openResults(teacher)"
              ></app-pap-autoevaluation-row>
            </ng-container>

            <ng-template #noResults>
              <tr class="no-results" height="76px">
                <td>
                  {{ t('pap/autoEvaluation/noResults') }}
                </td>
              </tr>
            </ng-template>
          </tbody>
        </table>
      </div>
    </div>

    <app-pagination
      *ngIf="teacherList.results.length > 0"
      [(page)]="page"
      (pageChange)="onPageChange($event)"
      [collectionSize]="teacherList.count"
      [pageSize]="limit"
      [showLimitSelector]="true"
      (limitChange)="onLimitChange($event)"
    ></app-pagination>
  </ng-container>
</div>
